import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaidarshancabsservice() {



const cardData = {
  keyword: "Mumbai Darshan Cabs Service",
  heading: "Lotus Cab: Mumbai Darshan Cabs Service",

  headingDescription:
    "Lotus Cab offers premium Mumbai Darshan Cabs Service for travelers who want to explore the financial capital of India in comfort and style. Whether you are planning a half-day city tour, full-day Mumbai sightseeing, weekend family trip, or corporate guest visit, we provide flexible tour packages with professional chauffeur-driven vehicles. Our fleet includes AC sedans, spacious SUVs, luxury cars, and mini buses for group travel. From iconic landmarks like Gateway of India and Marine Drive to Siddhivinayak Temple and Bandra Sea Link, we ensure a smooth and well-planned sightseeing experience. Transparent pricing, customizable itineraries, and punctual pickup make our Mumbai Darshan service reliable and convenient. With experienced drivers who know Mumbai’s traffic patterns and routes, Lotus Cab ensures your city tour is safe, comfortable, and memorable.",

  top: "Top Places Covered in Mumbai Darshan with Lotus Cab",

  topPlaces: [
    {
      title: "Gateway of India",
      description:
        "Gateway of India is Mumbai’s most iconic landmark located near the Arabian Sea. Tourists from across India and abroad visit this historical monument built during the British era. A Mumbai Darshan cab ensures easy access without worrying about parking or traffic. AC vehicles provide comfortable travel even during peak tourist seasons. Lotus Cab offers flexible waiting time for photography and ferry visits."
    },
    {
      title: "Marine Drive",
      description:
        "Marine Drive, also known as the Queen’s Necklace, offers stunning sea views and evening sunsets. It is one of Mumbai’s most visited scenic spots. Comfortable cab service ensures relaxed travel along the coastline."
    },
    {
      title: "Siddhivinayak Temple",
      description:
        "Siddhivinayak Temple is one of the most famous temples in Mumbai attracting thousands of devotees daily. A chauffeur-driven cab ensures timely darshan visits."
    },
    {
      title: "Bandra-Worli Sea Link",
      description:
        "This iconic sea bridge connects Bandra and Worli offering scenic ocean views. SUV and luxury cabs enhance the driving experience."
    },
    {
      title: "Haji Ali Dargah",
      description:
        "Located in the Arabian Sea, Haji Ali Dargah is a major spiritual destination in Mumbai. Comfortable AC travel ensures smooth temple visits."
    },
    {
      title: "Juhu Beach",
      description:
        "Juhu Beach is popular for evening strolls and street food experiences. Round-trip cab service ensures stress-free travel."
    },
    {
      title: "Elephanta Caves",
      description:
        "Elephanta Caves are UNESCO heritage rock-cut caves accessible via ferry. Mumbai Darshan cab service provides timely port drop."
    },
    {
      title: "Colaba Causeway",
      description:
        "Colaba Causeway is famous for shopping and cafes. Flexible half-day cab booking helps explore local markets conveniently."
    }
  ],

 services: [
  {
    name: "Mumbai Darshan Cab",
    description:
      "Lotus Cab provides complete Mumbai Darshan cab service covering all major city attractions in a single well-planned tour. This package is ideal for families, tourists, corporate guests, and first-time visitors who want to explore Mumbai comfortably. Our professional drivers are experienced in navigating city traffic and planning efficient sightseeing routes. The service includes pickup from hotel, airport, railway station, or residence. Vehicles are fully air-conditioned, sanitized, and maintained for smooth travel. We offer flexible waiting time at each tourist location for photography and exploration. Transparent pricing ensures no hidden charges during the tour. Both half-day and full-day customized packages are available. With Lotus Cab, you experience Mumbai sightseeing safely, comfortably, and without stress."
  },
  {
    name: "AC Cab for Mumbai Darshan",
    description:
      "Our AC Cab for Mumbai Darshan ensures comfortable sightseeing in all seasons, especially during Mumbai’s humid climate. Fully air-conditioned vehicles provide a cool and relaxed travel experience throughout the tour. This option is perfect for senior citizens, children, and family travelers who prefer comfortable city travel. Professional chauffeurs ensure smooth driving across busy city roads. The cab covers all major attractions including temples, beaches, monuments, and shopping areas. Clean interiors and regular sanitization maintain hygiene standards. Flexible time duration options are available as per customer preference. Suitable for half-day or full-day Mumbai city tours. Lotus Cab guarantees punctual service and complete travel comfort."
  },
  {
    name: "Sedan Cab Mumbai Darshan",
    description:
      "Sedan Cab Mumbai Darshan service is ideal for small families, couples, and business visitors exploring the city. Comfortable seating for up to four passengers makes it perfect for compact sightseeing groups. The sedan offers smooth driving, fuel efficiency, and easy maneuvering through city lanes. Our trained drivers are familiar with key tourist destinations and alternate traffic routes. The service includes flexible pickup and drop locations within Mumbai. AC comfort enhances the overall travel experience during long city tours. Transparent fare structure ensures budget-friendly sightseeing. Ideal for personal, family, or short corporate city visits. Lotus Cab provides reliable sedan service with professional standards."
  },
  {
    name: "SUV Cab Mumbai Darshan",
    description:
      "SUV Cab Mumbai Darshan is designed for larger families and group travelers seeking extra space and comfort. Spacious seating and luggage capacity make it ideal for full-day sightseeing tours. SUV vehicles offer better road visibility and stability during long city travel. Professional drivers ensure smooth coordination across tourist locations. This service is suitable for weekend trips, religious tours, and extended family visits. AC comfort and clean interiors enhance the premium travel experience. Flexible hourly or package-based pricing is available. Perfect for group sightseeing with maximum convenience. Lotus Cab ensures safe and comfortable SUV travel across Mumbai."
  },
  {
    name: "Luxury Cab Mumbai Darshan",
    description:
      "Luxury Cab Mumbai Darshan service is crafted for VIP guests, executives, and premium travelers. High-end vehicles provide superior comfort, stylish interiors, and advanced safety features. This option is perfect for corporate delegations, special guests, and business tours. Chauffeurs are professionally trained for executive-level service. The vehicle ensures silent cabin experience and smooth city driving. Flexible scheduling allows customized sightseeing plans. Ideal for high-profile visitors who prefer premium transportation. Clean, polished vehicles reflect professional service standards. Lotus Cab guarantees luxury, safety, and exclusivity throughout the Mumbai Darshan journey."
  },
  {
    name: "Half Day Mumbai Darshan Cab",
    description:
      "Half Day Mumbai Darshan Cab is perfect for travelers with limited time who want to explore key attractions quickly. This 4–5 hour package covers major landmarks like Gateway of India, Marine Drive, and temples. It is ideal for business visitors and short layover tourists. The service includes flexible pickup from airport or hotel. Professional drivers manage time efficiently to cover important locations. AC comfort ensures relaxed short-duration travel. Transparent package pricing avoids unexpected costs. Suitable for morning or evening sightseeing plans. Lotus Cab ensures punctual and efficient half-day city tours."
  },
  {
    name: "Full Day Mumbai Darshan Cab",
    description:
      "Full Day Mumbai Darshan Cab offers an extensive 8–10 hour sightseeing experience covering beaches, temples, historical monuments, shopping streets, and scenic routes. Ideal for tourists who want a complete Mumbai exploration in one day. The service includes flexible itinerary customization as per customer interest. Spacious and air-conditioned vehicles ensure maximum comfort. Professional drivers guide you through the best routes and traffic conditions. Perfect for family vacations and weekend travelers. Transparent full-day pricing available with no hidden charges. Flexible stopovers for food and shopping included. Lotus Cab guarantees a comprehensive and memorable Mumbai tour experience."
  },
  {
    name: "Mini Bus Mumbai Darshan",
    description:
      "Mini Bus Mumbai Darshan service is ideal for large groups, school trips, corporate outings, and family gatherings. Comfortable seating for multiple passengers ensures everyone travels together. Spacious interiors provide convenience during long sightseeing tours. AC facility and clean seating enhance comfort throughout the journey. Professional drivers handle city navigation and parking coordination. Suitable for full-day Mumbai sightseeing packages. Affordable per-km and package-based pricing available. Safe and stable vehicle performance ensures smooth group travel. Lotus Cab offers reliable mini bus service for organized Mumbai city tours."
  }
],

  tableData: [
    ["Mumbai Darshan Cab", "Mumbai City Tour Cab"],
    ["AC Cab for Mumbai Darshan", "Sedan Cab Mumbai Darshan"],
    ["SUV Cab Mumbai Darshan", "Luxury Cab Mumbai Darshan"],
    ["Family Tour Cab Mumbai", "Group Tour Cab Mumbai"],
    ["Online Booking Mumbai Darshan Cab", "Chauffeur Driven Cab Mumbai"],
    ["One Way Mumbai Darshan Cab", "Round Trip Mumbai Darshan Cab"],
    ["Half Day Mumbai Darshan Cab", "Full Day Mumbai Darshan Cab"],
    ["Picnic Tour Cab Mumbai", "Weekend Trip Cab Mumbai"],
    ["Corporate Mumbai Darshan Cab", "Mini Bus Mumbai Darshan"],
    ["Best Cab Service Mumbai Darshan", "Affordable Cab Mumbai Darshan"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Complete City Coverage",
      WhyChoosedescription:
        "Covers all major tourist attractions in Mumbai with flexible route planning."
    },
    {
      WhyChooseheading: "Professional City Drivers",
      WhyChoosedescription:
        "Experienced chauffeurs familiar with Mumbai traffic and shortcuts."
    },
    {
      WhyChooseheading: "Flexible Tour Packages",
      WhyChoosedescription:
        "Half-day, full-day, and customized sightseeing plans available."
    },
    {
      WhyChooseheading: "Wide Fleet Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury car, and mini bus options available."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear fare structure without hidden charges."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription:
        "Well-maintained and sanitized vehicles for relaxed travel."
    },
    {
      WhyChooseheading: "Corporate & Family Friendly",
      WhyChoosedescription:
        "Suitable for business visitors, family outings, and group tours."
    },
    {
      WhyChooseheading: "Easy Online Booking",
      WhyChoosedescription:
        "Instant booking confirmation with 24/7 customer assistance."
    }
  ]
};

const faqData = [
  { question: "What places are covered in Mumbai Darshan?", answer: "Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, and other major landmarks are covered." },
  { question: "Is half-day booking available?", answer: "Yes, half-day sightseeing packages are available." },
  { question: "Are luxury vehicles available?", answer: "Yes, premium luxury car options are available." },
  { question: "Is mini bus available for groups?", answer: "Yes, mini bus service is available for group tours." },
  { question: "Is AC cab provided?", answer: "Yes, all vehicles are air-conditioned." },
  { question: "Is online booking available?", answer: "Yes, instant online booking is available." },
  { question: "Is corporate booking supported?", answer: "Yes, corporate city tour packages are available." },
  { question: "Are drivers experienced?", answer: "Yes, professional city chauffeurs are provided." },
  { question: "Is full-day booking available?", answer: "Yes, full-day sightseeing packages are available." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock assistance is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Shah",
    feedback:
      "Booked full-day Mumbai Darshan cab. Driver was knowledgeable and punctual. Very comfortable experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Family city tour was smooth and enjoyable. AC SUV was spacious and clean.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Excellent cab service for corporate guests visiting Mumbai. Professional and reliable.",
    rating: 5
  }
];

























































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Darshan Cabs Service",
  "image": "https://lotuscab.com/assets/images/mumbai-darshan-cabs.jpg", 
  "description": "Lotus Cab offers Mumbai Darshan cab services with AC, sedan, SUV, and luxury cabs. Perfect for family tours, group trips, weekend excursions, corporate outings, and picnic tours. Book online for chauffeur-driven one-way, round-trip, half-day, and full-day Mumbai city tours. Safe, comfortable, and affordable cab services with Mini Bus options available.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/mumbai-darshan-cabs-service"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Mumbai Darshan Cabs Service | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai Darshan cab services with Lotus Cab. AC, sedan, SUV, luxury cabs for family tours, group trips, weekend trips, corporate outings & picnic tours. Online booking available. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Darshan Cab, Mumbai City Tour Cab, AC Cab for Mumbai Darshan, Sedan Cab Mumbai Darshan, SUV Cab Mumbai Darshan, Luxury Cab Mumbai Darshan, Family Tour Cab Mumbai, Group Tour Cab Mumbai, Online Booking Mumbai Darshan Cab, Chauffeur Driven Cab Mumbai, One Way Mumbai Darshan Cab, Round Trip Mumbai Darshan Cab, Half Day Mumbai Darshan Cab, Full Day Mumbai Darshan Cab, Picnic Tour Cab Mumbai, Weekend Trip Cab Mumbai, Corporate Mumbai Darshan Cab, Mini Bus Mumbai Darshan, Best Cab Service Mumbai Darshan, Affordable Cab Mumbai Darshan" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaidarshancabsservice;